import { useTranslation } from "react-i18next";
import ImageHeader from "../../../../components/image-header/image-header";
import customizedImg from "../../../../assets/imgs/services/international/customized.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import Helmet from "react-helmet";

import customizedLogo from "../../../../assets/imgs/services/international/customized.svg";
import customizedCover from "../../../../assets/imgs/services/international/general.jpg";
import phoneIcon from "../../../../assets/imgs/services/international/telephone-icon.svg";
import { useQuill } from "react-quilljs";
import '../general/general.css'
import { Link } from "react-router-dom";
import { normalizeInternationalQuillContent } from "../shared/normalize-international-quill";

function Customized() {
  const [tCustomized] = useTranslation("customizedPage");
  const [tSMetaData] = useTranslation("metaData");
  const idCustomized = "7818a77c-3634-4a44-b753-354c0d8f16bb";
  const [textDescription, setTextDescription] = useState("");

  const {quill, quillRef} = useQuill({
    readOnly: true,
    modules: {toolbar: false}
  });

  useEffect(() => {
    // Solo ejecuta si quill existe Y textDescription tiene contenido
    if (quill && textDescription) {
      try {
        const content = JSON.parse(
          normalizeInternationalQuillContent(textDescription)
        );
        quill.setContents(content);
      } catch (e) {
        console.error("Error al parsear el contenido de Quill:", e);
      }
    }
  }, [textDescription, quill]);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["products-internacional-submenu"])[3]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["products-international-submenu"])[3]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idCustomized}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("customized.title")}</title>
        <meta
          name="description"
          content={tSMetaData("customized.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tCustomized("header.section")}
        title={tCustomized("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tCustomized("description.content"))
        }
        contactSales={tCustomized("header.contact-sales")}
        contactProductID="btnContactCustomized"
        imgBackground={customizedImg}
      /> */}
      <div className="container-fluid international-service-container">
        <div className="row">
          <div className="col-lg-4 border p-0"> 
            <img 
              src={customizedCover} 
              alt="General Service"
              className="img-service-cover"
            />
          </div>
          <div className="col-lg-8 border international-product-text">
            <img className="service-international-logo" src={customizedLogo} />
            <div>
              <div ref={quillRef}></div>
            </div>
            {/* <p className="mt-4 international-first-title">DESCRIPCIÓN</p>
            <p>
              Confianza y seguridad sin igual cuando para su embarque el tiempo es apremiante. 
              Manténgase tranquilo sabiendo que su carga será entregada de la manera más rápida 
              y segura. Desde la reserva hasta su entrega, su embarque GOLD es manejado con 
              sumo cuidado, con selección de vuelo, vuelo de respaldo, alta prioridad en abordaje 
              y las conexiones más rápidas.
            </p>
            <p className="international-first-title">CARACTERÍSTICAS Y BENEFICIOS</p>
            <ul>
              <li>Para embarques que son transportados en un vuelo específico.</li>
              <li>Prioridad en el abordaje y pronta entrega en el aeropuerto de destino.</li>
              <li>Asignación de vuelo al momento de la documentación.</li>
              <li>Aplica sólo en mercancía general.</li>
            </ul> */}
            <Link to={tCustomized("link-contact")} className="btn-contact-seller">
              <img src={phoneIcon} />
              <span>{tCustomized("header.contact-sales")}</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Customized;
